import React, { useCallback } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
} from "@themesberg/react-bootstrap";
import Cards from "react-credit-cards";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { fetchApi, postApi, verifyToken } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-hot-toast";
import {
  faBook,
  faChartLine,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import BackButton from "../../../components/BackButton";
import { Routes } from "../../../routes";
// import PaymentModal from './PaymentModal'
import { MODULE_TYPES, formatNumber } from "../../../redux/utils";
import CustomButton from "../../../components/CustomButton";
import { bankList, accountTypes } from "../../accounts/AccountForm";
import { Typeahead } from "react-bootstrap-typeahead";
import PaymentPreviewModal from "./PaymentPreviewModal";
import { Badge, ButtonGroup } from "react-bootstrap";

function DSTOffice({ match, pageType = "batch", type = null }) {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState({});
  const [focus, setFocus] = useState("name");
  const [deleteAllWarningModalIsOpen, setDeleteAllWarningModalOpen] =
    useState(false);
  const [deleteSignleWarningModalIsOpen, setDeleteSignleWarningModalOpen] =
    useState(false);
  const toggleDeleteAll = () => setDeleteAllWarningModalOpen((p) => !p);
  const toggleDeleteSingle = () => setDeleteSignleWarningModalOpen((p) => !p);
  const [warningIsOpen, setWarningModalIsOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState("");
  const [_loading, _setLoading] = useState(false);
  const isReceivingOffice = location.pathname.includes("receiving-office");
  const isChequesOffice = location.pathname.includes("cheques-office");
  const isExpenditureCashOffice = location.pathname.includes("expenditure-cash-office");
  const isRecurrentCashOffice = location.pathname.includes("recurrent-cash-office");
  const isAlliedCashOffice = location.pathname.includes("allied-cash-office");
  const isDstPendingScheduleffice = location.pathname.includes(
    "/dst-pending-schedule"
  );
  const isSTReview = location.pathname.includes("sub-treasurer-payment-review");
  const isApprovedPayment = location.pathname.includes("approved-payments");
  const isDstCashbackingCheck = location.pathname.includes(
    "dst-office/view-schedule"
  );
  const isHeadChequesOffice = location.pathname.includes("isHeadChequesOffice");

  const toggleWarning = () => setWarningModalIsOpen((p) => !p);

  const history = useNavigate();
  const goBackFun = () => {
    history(-2);
  };
  const batch_no = useParams().batch_no;
  const [paymentScheduleTable, setPaymentScheduleTable] = useState([]);
  const [tresuryDetails, setTresuryDetails] = useState({});
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [processing, setProcessing] = useState(false);

  const [changeAmount, setChangeAmount] = useState(false);
  const [modal, setModal] = useState(false);
  const toggle1 = () => setModal((p) => !p);
  const [rowData, setRowData] = useState([]);
  const [paymentAccountList, setPaymentAccountList] = useState([]);
  const [selectedPaymentAccount, setSelectedPaymentAccount] = useState();
  const [paymentModalIsOpen, setPaymentModalIsOpen] = useState(false);
  const [selectedRowForPayment, setSelectedRowForPayment] = useState([]);
  const [selectedForApproval, setSelectedForApproval] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editForm, setEditForm] = useState({
    contractor_acc_name: "",
    contractor_acc_no: "",
    contractor_bank: "",
    account_type: "",
    contractor_acc_sort_code: "",
  });
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [archivingItem, setArchivingItem] = useState(null);

  const handleArchive = () => {
    // alert(archivingItem?.pvInfo?.pv_code)
    // return
    const batch_no = archivingItem?.pvInfo?.pv_code || archivingItem?.pvInfo?.batch_no;

    if (!batch_no) {
      toast.error("Batch ID not found");
      return;
    }

    setProcessing(true);
    postApi(`get_batch_list`, {
      query_type: "archive_update",
      batch_no: batch_no,
    })
      .then((resp) => {
        setProcessing(false);
        if (resp && resp.success) {
          toast.success("Item Archived Successfully");
          setArchiveModalOpen(false);
          setArchivingItem(null);
          // Go back as the whole batch is now archived and should be removed from current view
          history(-1);
        } else {
          toast.error(resp.message || "Failed to archive item");
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.error(err);
        toast.error("An error occurred while archiving");
      });
  };

  useEffect(() => {
    fetchApi("pan_details/get")
      .then((resp) => {
        if (resp) {
          setPaymentAccountList(resp.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const getApprovalInfoByLineItem = async (info) => {
    try {
      return await postApi(`post_approval_collection`, {
        form: {
          query_type: "get_by_line_item",
          approval_no: info.approval_no,
          mda_code: info.mda_code,
          mda_economic_code: info.economic_code,
        },
      });
    } catch (error) {
      return error;
    }
  };

  const [form, setForm] = useState({
    batch_number: "",
    date: "",
    no_of_mda: "",
    no_of_payments: "",
    total_amount: "",
    bulk_description: "Disbursement",
    cheque_number: "",
    query_type: "insert",
    status: "uncommited",
    amount: "",
  });
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const toggle = () => setModalIsOpen((p) => !p);
  const isST = user.role === "sub_treasury";
  const isUpdatePage = pageType === "update";
  const isCommitPage = pageType === "commit";

  const fetchBatchData = useCallback(() => {
    setLoading(true);
    postApi(`get_batch_list`, {
      query_type: "select_by_batch_no",
      status: isChequesOffice || isRecurrentCashOffice || isAlliedCashOffice || isExpenditureCashOffice
        ? "Schedule Approved By DST"
        : isDstPendingScheduleffice
          ? "Schedule Approved By Cheques Office"
          : isSTReview
            ? "Payment Approved By DST"
            : isApprovedPayment
              ? "Payment Approved By Sub Treasurer"
              : "Schedule Approved By Checking Office",
      batch_no,
      // type: user.role,
    })
      .then((data) => {
        if (data && data.success && data.result && data.result.length) {
          setPaymentScheduleTable(data.result);
          setTresuryDetails(data.result[0]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [
    batch_no,
    isChequesOffice,
    isDstPendingScheduleffice,
    isSTReview,
    isApprovedPayment,
  ]);

  useEffect(() => {
    fetchBatchData();
  }, [fetchBatchData]);



  const approveIndividualPayment = (item) => {
    if (
      !item.approvalInfo ||
      !item.approvalInfo.cb_amount ||
      item.approvalInfo.cb_amount <= 0
    ) {
      toast.error("This item has no cash backed amount.");
      return;
    }

    if (
      isDstCashbackingCheck &&
      (!item.pvInfo.contractor_acc_name ||
        !item.pvInfo.contractor_acc_no ||
        !item.pvInfo.contractor_bank)
    ) {
      toast.error("Please check contractor account details before approving.");
      return;
    }

    setSelectedForApproval([item]);
    toggleWarning();
  };

  const handleApi = () => {
    let status = "";
    if (isChequesOffice) {
      status = "Schedule Approved By Cheques Office";
    } else if (isDstPendingScheduleffice) {
      status = "Payment Approved By DST";
    } else if (isSTReview) {
      status = "Payment Approved By Sub Treasurer";
    } else if (isDstCashbackingCheck) {
      status = "Schedule Approved By DST";
    }

    let notif_key = "";
    if (isDstCashbackingCheck) {
      notif_key = "Cash Office (ST)";
    } else if (isChequesOffice) {
      notif_key = "Review Payment (DST)";
    } else if (isDstPendingScheduleffice) {
      notif_key = "Sub Treasurer";
    } else if (isSTReview) {
      notif_key = "Approved Payments";
    }

    if (
      isDstCashbackingCheck &&
      !selectedPaymentAccount &&
      !paymentScheduleTable[0]?.payment_account_name
    ) {
      toast.error("Please select a payment account!");
      setWarningModalIsOpen(false);
      return;
    }

    _setLoading(true);
    postApi(`post_contractor_payment_schedule_array`, {
      paymentScheduleTable: selectedForApproval.map((item) => ({
        ...item.approvalInfo,
        ...item.pvInfo,
      })),
      query_type: "update_payment",
      status: status,
      paymentAccount: selectedPaymentAccount,
      bulkDescription:
        form?.bulk_description && form?.bulk_description !== ""
          ? form?.bulk_description
          : "Payment",
      userId: user.username,
      notif_key: notif_key,
      mda_name: "",
      approval_no: selectedForApproval[0]?.pvInfo.approval_no,
    })
      .then((data) => {
        _setLoading(false);
        if (data.success) {
          toast.success("Payment Approved Successfully");
          setWarningModalIsOpen(false);
          if (isChequesOffice) {
            history(`${Routes.paymentSchedule.paymentSchedulePdf}/${batch_no}`);
          } else {
            history(-2);
          }
        }
      })

      .catch((err) => {
        _setLoading(false);
        toast.error(err);
      });
  };
  const handleAllReturned = () => {
    if (isST) {
      postApi(`post_contractor_payment_schedule_array`, {
        paymentScheduleTable,
        query_type: "update",
        status: "remove",
        type: user.role,
        contractor_code: batch_no,
      })
        .then((data) => {
          if (data.success) {
            console.log(data);
            history(-2);
          }
        })

        .catch((err) => {
          console.log(err);
          toast.success("An error occurred");
        });
    } else {
      postApi(`post_payment_schedule_array`, {
        paymentScheduleTable,
        query_type: "update",
        status: "remove",
        type: user.role,
        contractor_code: batch_no,
      })
        .then((data) => {
          if (data.success) {
            console.log(data);
            history(-2);
          }
        })

        .catch((err) => {
          console.log(err);
          toast.error("An error occurred");
        });
    }
  };

  const submitIndividualItem = (id) => {
    const newArray = paymentScheduleTable.filter((itm, idx) => itm.id === id);
    if (isST) {
      postApi(`post_contractor_payment_schedule_array`, {
        paymentScheduleTable: newArray,
        query_type: "update",
        type: user.role,
        status: "remove",
      })
        .then((data) => {
          if (data.success) {
            toast.success("Deleted Successfully");
            history(-2);
          }
        })

        .catch((err) => {
          toast.error(err);
        });
    } else {
      console.log("newArray", newArray);
      postApi(`post_payment_schedule_array`, {
        paymentScheduleTable: newArray,
        query_type: "update",
        type: user.role,
        status: "remove",
      })
        .then((data) => {
          if (data.success) {
            console.log(data);
            history(-2);
          }
        })

        .catch((err) => {
          toast.error(err);
        });
    }
  };

  const handleChange = (id, name, value, e) => {
    // const {name, value} = e.target

    // const value1 = addCommas(removeNonNumeric(value))
    // const value1 = addCommas(value)
    const newArray = [];

    paymentScheduleTable.forEach((itm, idx) => {
      if (itm.id === id) {
        newArray.push({ ...itm, [name]: value });
      } else {
        newArray.push(itm);
      }
    });

    setPaymentScheduleTable(newArray);
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;

    setForm((p) => ({ ...p, [name]: value }));
  };

  useEffect(() => {
    postApi(`get_batch_list`, {
      query_type: "select_payment_list",
      status: isCommitPage ? "auditor_approved" : "pending",
      batch_no,
      type: user.role,
    })
      .then((data) => {
        console.log("gg", data);
        if (data.result) {
          setPaymentDetails(data.result);
          const formData = data.result[0];
          setForm((p) => ({ ...p, ...formData }));
          // setPaymentScheduleTable(data.result);
        }
      })

      .catch((err) => {
        // alert(err);
        // setLoadSpinner(false);
      });
  }, [batch_no, user.role, isCommitPage]);

  const updatePaymentSchedule = () => {
    if (isST) {
      postApi(`post_contractor_payment_schedule_array`, {
        paymentScheduleTable,
        query_type: "update_by_batch_no",
        status: "Committed",
        cheque_number: form.cheque_number,
        arabic_date: form.arabic_date,
        type: user.role,
      })
        .then((data) => {
          if (data.success) {
            console.log("hell", data);
            // setOpenPdf(true)
            // if (type === MODULE_TYPES.MAIN_TREASURY) {
            //   history(`${Routes.payments.viewPDF}/${batch_no}`)
            // } else if (type === MODULE_TYPES.SUB_TREASURY) {
            history(`${Routes.payments.viewStPDF}/${batch_no}`);
            // }
          }
        })

        .catch((err) => {
          toast.error(err);
        });
    } else {
      postApi(`post_payment_schedule_array`, {
        paymentScheduleTable,
        query_type: "update_by_batch_no",
        status: "Committed",
        cheque_number: form.cheque_number,
        arabic_date: form.arabic_date,
        type: user.role,
      })
        .then((data) => {
          if (data.success) {
            console.log("hell", data, type);
            // setOpenPdf(true)
            if (type === MODULE_TYPES.MAIN_TREASURY) {
              history(`${Routes.payments.viewPDF}/${batch_no}`);
            } else if (type === MODULE_TYPES.SUB_TREASURY) {
              history(`${Routes.payments.viewStPDF}/${batch_no}`);
            }
          }
        })

        .catch((err) => {
          toast.error(err);
        });
    }
  };

  const submitChequeNo = () => {
    postApi(`post_check_details`, {
      form,
      type: user.role,
    })
      .then((data) => {
        updatePaymentSchedule();
        if (data.success) {
          console.log("hello", data);

          // toggle()
          // history("/dashboard/intAudit")
        }
      })

      .catch((err) => {
        toast.error(err);
      });
  };

  const totalAmount = paymentScheduleTable.reduce(
    (a, b) => a + parseFloat(b.amount),
    0
  );

  // const renderRow = (item, index) =>  (
  //   <tr key={index}>
  //     <td>{item.pv_code}</td>
  //     <td>{item.mda_name}</td>
  //     <td style={{ width: "5%" }}  >{item.description}</td>
  //     <td>{item.approval_no}</td>
  //     <td className='text-end'>{formatNumber(item.amount)}</td>
  //     <td className='text-end'>{formatNumber(item.amount)}</td>
  //     <td>
  //       <>
  //         <Button
  //             className="me-1 m-1"
  //             size="sm" disabled
  //             // onClick={() => {setItemToDelete(item.id); toggleDeleteSingle()}}
  //           >
  //             Attachment
  //           </Button>
  //           <Button
  //             className="btn-danger"
  //             size="sm"
  //             // onClick={() => {setItemToDelete(item.id); toggleDeleteSingle()}}
  //           >
  //             Return
  //           </Button>
  //       </>
  //     </td>
  //   </tr>
  // )
  // const renderTableBody = () => {
  //    paymentScheduleTable.map(item => {
  //     getApprovalInfoByLineItem(item).then(resp => (
  //        <h1>ssd</h1>
  //     )).catch(err => {
  //       return "Error"
  //     })

  //   })
  // }

  const openEditModal = (item) => {
    setEditingItem(item);
    setEditForm({
      contractor_acc_name: item.pvInfo.contractor_acc_name || "",
      contractor_acc_no: item.pvInfo.contractor_acc_no || "",
      contractor_bank: item.pvInfo.contractor_bank || "",
      account_type: item.pvInfo.account_type || "",
      contractor_acc_sort_code: item.pvInfo.contractor_acc_sort_code || "",
    });
    setEditModalOpen(true);
  };

  const handleSaveAccountDetails = () => {
    if (
      !editForm.contractor_acc_name ||
      !editForm.contractor_acc_no ||
      !editForm.contractor_bank
    ) {
      toast.error("All fields are required");
      return;
    }

    _setLoading(true);
    postApi(`update_contractor_details`, {
      batch_no: batch_no,
      approval_no: editingItem.pvInfo.approval_no,
      pv_code: editingItem.pvInfo.pv_code,
      contractor_bank: editForm.contractor_bank,
      contractor_acc_sort_code: editForm.contractor_acc_sort_code,
      contractor_acc_name: editForm.contractor_acc_name,
      contractor_acc_no: editForm.contractor_acc_no,
      account_type: editForm.account_type,
    })
      .then((resp) => {
        _setLoading(false);
        if (resp && resp.success) {
          toast.success("Details updated successfully");
          setEditModalOpen(false);
          fetchBatchData();
        } else {
          toast.error(resp.message || "Failed to update details");
        }
      })
      .catch((err) => {
        _setLoading(false);
        console.error(err);
        toast.error("An error occurred while updating details");
      });
  };

  const validateAccountDetails = (items = rowData) => {
    if (!isDstCashbackingCheck) return true;

    const invalidItems = items.filter(
      (item) =>
        !item.pvInfo.contractor_acc_name ||
        !item.pvInfo.contractor_acc_no ||
        !item.pvInfo.contractor_bank
    );

    if (invalidItems.length > 0) {
      toast.error(
        "Please provide Account Details."
      );
      return false;
    }
    return true;
  };

  const renderRow = (item, index, disableAction = false) => (
    <tr key={index}>
      {isApprovedPayment && (
        <td>
          {!disableAction && (
            <>
              <Button
                size="sm"
                className="btn-success mb-1"
                onClick={() => {
                  setSelectedRowForPayment([item]);
                  setPaymentModalIsOpen(true);
                }}
              >
                Process Payment
              </Button>
              <Button
                size="sm"
                className="btn-info ms-1"
                onClick={() => {
                  setArchivingItem(item);
                  setArchiveModalOpen(true);
                }}
              >
                Archive
              </Button>
            </>
          )}
        </td>
      )}
      <td>{item.pvInfo.pv_code}</td>
      <td>{item.pvInfo.mda_name}</td>
      <td style={{ width: "5%" }}>{item.pvInfo.description}</td>
      <td>{item.pvInfo.approval_no}</td>
      <td className="text-end">{formatNumber(item.pvInfo.amount)}</td>
      <td className="text-end">
        {item.approvalInfo ? formatNumber(item.approvalInfo.cb_amount) : "0"}
      </td>
      <td>
        <div>
          <b>Account Name:</b> {item.pvInfo.contractor_acc_name}
        </div>
        <div>
          <b>Account No:</b> {item.pvInfo.contractor_acc_no}
        </div>
        <div>
          <b>Bank Name:</b> {item.pvInfo.contractor_bank}
        </div>
        <div>
          <b>Account Type:</b> {item.pvInfo.account_type}
        </div>
        <div>
          <b>Sort Code:</b> {item.pvInfo.contractor_acc_sort_code}
        </div>
        {isDstCashbackingCheck &&
          (!item.pvInfo.contractor_acc_name ||
            !item.pvInfo.contractor_acc_no ||
            !item.pvInfo.contractor_bank) && (
            <div className="mt-1">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openEditModal(item);
                }}
                className="text-info"
                style={{ fontSize: "11px", textDecoration: "underline" }}
              >
                Edit Account Details
              </a>
            </div>
          )}
      </td>
      <td className="text-center">
        <Badge className="p-1">{item?.pvInfo?.payment_status}</Badge>
      </td>
      <td>
        <Button
          className="me-1 m-1"
          size="sm"
          onClick={() =>
            history(
              `${Routes.cashBacking.releaseCollectionPDF}?approval_no=${encodeURIComponent(item.pvInfo.approval_no)}`
            )
          }
        >
          Release
        </Button>
        <Button
          className="me-1 m-1"
          size="sm"
          onClick={() => {
            history(
              `${Routes.pv.pvReportView}?approval_no=${encodeURIComponent(item.pvInfo.approval_no)}&approval_type=${item.pvInfo.approval_type}&pv_code=${item.pvInfo.pv_code}`
            );
          }}
        >
          PV
        </Button>

        <Button className="me-1 m-1" size="sm" disabled>
          Attachments
        </Button>
      </td>
      {disableAction ||
        isSTReview ||
        isApprovedPayment ? null : (
        <td>
          <div className="d-flex flex-column gap-2">
            {(isDstCashbackingCheck || isChequesOffice) && (
              <Button
                size="sm"
                className="btn-primary"
                onClick={() => approveIndividualPayment(item)}
              >
                {isChequesOffice ? "Approve & Print Schedule" : "Approve Schedule"}
              </Button>
            )}
            
          </div>
        </td>
      )}
    </tr>
  );

  useEffect(() => {
    const fetchData = async () => {
      const updatedData = await Promise.all(
        paymentScheduleTable.map(async (item) => {
          try {
            const resp = await getApprovalInfoByLineItem(item);
            return {
              pvInfo: item,
              approvalInfo:
                resp.result && resp.result.length ? resp.result[0] : {},
            };
          } catch (error) {
            console.error("Error fetching data:", error);
            return { pvInfo: item, approvalInfo: {} };
          }
        })
      );
      setRowData(updatedData.filter((item) => item !== null));
    };

    if (paymentScheduleTable.length) {
      fetchData();
    }
  }, [paymentScheduleTable]);

  return (
    <>
      <Row>
        <Col md={3} className="">
          <BackButton />
        </Col>
        <Col md={6}>
          <h4 className="text-center">
            <FontAwesomeIcon icon={faBook} className="me-2" />{" "}
            {isUpdatePage || isCommitPage ? "Payment List" : "Review Schedule"}
          </h4>
        </Col>
      </Row>
      {/* {JSON.stringify(type)} */}

      {isUpdatePage ? null : (
        <Card className="p-2">
          <Row>
            <Col md={4}>
              {/* {isST ? null : (
                <h6>Bank Name : {tresuryDetails.treasury_bank_name}</h6>
              )} */}

              <h6>Batch No. : {batch_no}</h6>
              {/* {JSON.stringify(isChequesOffice)} */}
              {
                //<h6>Balance :</h6>
              }
            </Col>
            <Col md={4}>
              <h6>Total Amount : {formatNumber(totalAmount)}</h6>
            </Col>

            {isDstPendingScheduleffice || isSTReview || isApprovedPayment ? (
              <Col md={4}>
                <Button
                  className="me-1 m-1"
                  size="sm"
                  onClick={() =>
                    history(
                      `${Routes.paymentSchedule.paymentSchedulePdf}/${batch_no}`
                    )
                  }
                >
                  View Schedule
                </Button>
              </Col>
            ) : null}
          </Row>
          {/* {JSON.stringify(selectedPaymentAccount)}jkjkjkj */}
          <Row>
            <Col md={8}>
              {isDstCashbackingCheck ? (
                <div className="my-4 row">
                  <div className="col-md-6">
                    <label>
                      Select Payment Account
                      <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      onChange={({ target: { value } }) =>
                        setSelectedPaymentAccount(value)
                      }
                    >
                      <option value="">--select--</option>
                      {paymentAccountList
                        .filter((item) => item.type === "SUB-TREASURY ACCOUNT")
                        .map((item, id) => {
                          let selected = bankList.find(
                            (i) => i.code === item.bank_code
                          );
                          return (
                            <option value={item.id} key={id}>
                              {item.account_name} ({item.account_number} -{" "}
                              {selected.title})
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="col-md-6">
                    {/* <label>
                      Bulk Descripton<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      value={form.bulk_description}
                      onChange={({ target: { value } }) =>
                        setForm((p) => ({ ...p, bulk_description: value }))
                      }
                    /> */}
                  </div>
                </div>
              ) : (
                <div>
                  <h6>Payment Account:</h6>
                  {paymentScheduleTable && paymentScheduleTable.length ? (
                    <div>
                      <div>
                        Account Name:{" "}
                        {paymentScheduleTable[0].payment_account_name}
                      </div>
                      <div>
                        Bank Name:{" "}
                        {
                          bankList.find(
                            (i) =>
                              i.code ===
                              paymentScheduleTable[0].payment_bank_code
                          )?.title
                        }
                      </div>
                      <div>
                        Account Number:{" "}
                        {paymentScheduleTable[0].payment_account_number}
                      </div>
                    </div>
                  ) : (
                    <div>Not Selected</div>
                  )}
                </div>
              )}
            </Col>
            <Col>
              {/* {isApprovedPayment ? (
                <h4>
                  Payment Status: <span className="text-danger">Pending </span>
                </h4>
              ) : null} */}
            </Col>
          </Row>
        </Card>
      )}

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        {loading && <p>Please wait...</p>}
        <Card.Body className="p-0">
          {/* {JSON.stringify(rowData)} */}

          <table id="customers">
            <thead>
              <tr>
                {isApprovedPayment && <th>ACTION</th>}
                <th>PV CODE</th>
                <th>MDA NAME</th>
                <th style={{ width: "5%" }}>DESCRIPTION</th>
                <th>APPROVAL</th>
                <th>AMOUNT</th>
                <th>
                  {isDstPendingScheduleffice || isSTReview || isApprovedPayment
                    ? "AMOUNT PAID"
                    : "CASH BACKED AMOUNT"}
                </th>
                <th>PAYEE'S ACCOUNT DETAILS</th>
                <th>PAYMENT STATUS</th>
                <th>DOCUMENTS</th>
                {isDstPendingScheduleffice ||
                  isSTReview ||
                  isApprovedPayment ? null : (
                  <th>ACTION</th>
                )}
              </tr>
            </thead>
            <tbody>
              {rowData.map((item, index) => renderRow(item, index))}
            </tbody>
          </table>
          {/* <CustomTable
            size="sm"
            fields={fields}
            data={paymentScheduleTable}
            // currentPage={currentPage}
            // handlePageChange={handlePageChange}
          /> */}
        </Card.Body>
        {isUpdatePage ? null : isApprovedPayment ? (
          <Card.Footer>
            <center className="my-2">
              <CustomButton
                onClick={() => {
                  setSelectedRowForPayment(rowData);
                  setPaymentModalIsOpen(true);
                }}
              >
                <img
                  src="https://asset.brandfetch.io/idxE04AMjS/idL34Q6qIN.png"
                  alt="interswitch_logo"
                  height={"30px"}
                  className="me-2"
                />
                Process Payment
              </CustomButton>
            </center>
          </Card.Footer>
        ) : (
          <Card.Footer>
            <center>
              {isCommitPage ? null : (
                <Button
                  className="btn-danger me-3 "
                  onClick={() => {
                    setDeleteAllWarningModalOpen(true);
                  }}
                >
                  Return
                </Button>
              )}{" "}
              <CustomButton
                className=""
                loading={loading}
                onClick={
                  isCommitPage
                    ? toggle
                    : isDstPendingScheduleffice ||
                      isSTReview ||
                      isApprovedPayment
                      ? () => {
                        const items = rowData.filter(
                          (it) =>
                            it.approvalInfo &&
                            it.approvalInfo.cb_amount &&
                            it.approvalInfo.cb_amount > 0
                        );
                        setSelectedForApproval(items);
                        toggleWarning();
                      }
                      : isChequesOffice
                        ? () => {
                          setSelectedForApproval(rowData);
                          toggleWarning();
                        }
                        : () => {
                          const cashBackedItems = rowData.filter(
                            (it) =>
                              it.approvalInfo &&
                              it.approvalInfo.cb_amount &&
                              it.approvalInfo.cb_amount > 0
                          );

                          if (
                            isDstCashbackingCheck &&
                            cashBackedItems.length === 0
                          ) {
                            toast.error(
                              "There is no cash backed amount for these items."
                            );
                            return;
                          }

                          if (
                            validateAccountDetails(
                              isDstCashbackingCheck
                                ? cashBackedItems
                                : rowData
                            )
                          ) {
                            setSelectedForApproval(
                              isDstCashbackingCheck
                                ? cashBackedItems
                                : rowData
                            );
                            toggleWarning();
                          }
                        }
                }
              >
                <FontAwesomeIcon icon={faCheck} className="me-2" />
                {isCommitPage
                  ? "Continue"
                  : isChequesOffice
                    ? "Approve & Print Schedule"
                    : isDstPendingScheduleffice || isSTReview || isApprovedPayment
                      ? "Review Payment"
                      : "Approve Schedulefffff"}
              </CustomButton>
            </center>
          </Card.Footer>
        )}
      </Card>
      <PaymentPreviewModal
        isOpen={paymentModalIsOpen}
        toggle={() => setPaymentModalIsOpen((p) => !p)}
        paymentList={selectedRowForPayment}
        goBackFun={goBackFun}
      />
      {/* <PaymentModal
        toggle={toggle}
        submitChequeNo={submitChequeNo}
        modal={modal}
        paymentDetails={paymentDetails}
        form={form}
        handleChange={handleChange1}
      /> */}
      <Modal show={warningIsOpen} onHide={toggleWarning} size="xl">
        <Modal.Header onHide={toggleWarning}>
          <h4>Confirm Payments</h4>
          {/* {JSON.stringify(rowData[0]?.pvInfo.approval_no)} */}
        </Modal.Header>
        <Modal.Body className="text-center">
          <h5>The following payment will be processed</h5>

          {selectedForApproval.length ? (
            <table id="customers">
              <thead>
                <tr>
                  {isApprovedPayment && <th>ACTION</th>}
                  <th>PV CODE</th>
                  <th>MDA NAME</th>
                  <th style={{ width: "5%" }}>DESCRIPTION</th>
                  <th>APPROVAL</th>
                  <th>AMOUNT</th>
                  <th>CASH BACKED AMOUNT</th>
                  <th>PAYEE'S ACCOUNT DETAILS</th>
                  <th>PAYMENT STATUS</th>
                  <th>DOCUMENTS</th>
                </tr>
              </thead>
              <tbody>
                {selectedForApproval.map((item, index) =>
                  renderRow(item, index, true)
                )}
              </tbody>
            </table>
          ) : (
            <div>
              <Alert>NO PV WITH CASH BACKING FOUND</Alert>
            </div>
          )}
        </Modal.Body>
        {selectedForApproval.length ? (
          <Modal.Footer>
            <div>
              <Button
                outline
                className="m-1 p-1 px-3 bg-danger"
                onClick={toggleWarning}
              >
                Cancel
              </Button>
              <Button
                color="danger"
                className="m-1 p-1 px-3"
                onClick={handleApi}
                loading={_loading}
              >
                Process Payments
              </Button>
            </div>
          </Modal.Footer>
        ) : null}
      </Modal>
      {/* <Modal show={deleteSignleWarningModalIsOpen} onHide={toggleDeleteSingle}>
          <Modal.Header onHide={toggleDeleteSingle}>Return</Modal.Header>
          <Modal.Body className="text-center">
            <h5>Are you sure you want to return this item? </h5>
          </Modal.Body>
          <Modal.Footer>
            <div>
              
              <Button outline className="btn-primary m-1 p-1 px-3" onClick={toggleDeleteAll}>
                Cancel
              </Button>
              <Button
                color="danger"
                className="m-1 p-1 px-3"
                onClick={() => submitIndividualItem(itemToDelete)}
                loading={_loading}
              >
                Return
              </Button>
            </div>
          </Modal.Footer>
        </Modal> */}
      <Modal show={editModalOpen} onHide={() => setEditModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Account Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Account Name</Form.Label>
            <Form.Control
              type="text"
              value={editForm.contractor_acc_name}
              onChange={(e) =>
                setEditForm({
                  ...editForm,
                  contractor_acc_name: e.target.value,
                })
              }
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Account No</Form.Label>
            <Form.Control
              type="text"
              value={editForm.contractor_acc_no}
              onChange={(e) =>
                setEditForm({ ...editForm, contractor_acc_no: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Bank Name</Form.Label>
            <Typeahead
              id="bank-selection"
              labelKey="title"
              options={bankList}
              placeholder="Select Bank"
              selected={
                bankList.filter(
                  (bank) => bank.title === editForm.contractor_bank
                ) || []
              }
              onChange={(selected) => {
                const value =
                  selected.length > 0 ? selected[0].title : "";
                setEditForm({ ...editForm, contractor_bank: value });
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Account Type</Form.Label>
            <Form.Select
              value={editForm.account_type}
              onChange={(e) =>
                setEditForm({ ...editForm, account_type: e.target.value })
              }
            >
              <option value="">Select Account Type</option>
              {accountTypes.map((item, id) => (
                <option key={id} value={item.title}>
                  {item.title}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Sort Code</Form.Label>
            <Form.Control
              type="text"
              value={editForm.contractor_acc_sort_code}
              onChange={(e) =>
                setEditForm({
                  ...editForm,
                  contractor_acc_sort_code: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEditModalOpen(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveAccountDetails}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={archiveModalOpen} onHide={() => setArchiveModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Archive</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center text-danger">
          <h5>Are you sure you want to archive this item?</h5>
          <div className="mt-4 text-start">
            <p><strong>Batch ID:</strong> {archivingItem?.pvInfo?.batch_id || archivingItem?.pvInfo?.batch_no}</p>
            <p><strong>Approval Number:</strong> {archivingItem?.pvInfo?.approval_no}</p>
            <p><strong>PV Number:</strong> {archivingItem?.pvInfo?.pv_code}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setArchiveModalOpen(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleArchive}>
            Confirm Archive
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DSTOffice;
